import { useEffect, useState } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppRoot } from '@telegram-apps/telegram-ui';

import { Layout } from '@/components/Layout';
import { Landing } from '@/pages/Landing';
import { Games } from '@/pages/Games';
import { GameRoom } from '@/pages/GameRoom';
import { TicketPurchase } from '@/pages/TicketPurchase';
import { BotMoney } from '@/pages/BotMoney';
import { Profile } from '@/pages/Profile';
import { Leaderboard } from '@/pages/Leaderboard';

export function App() {
    const [platform, setPlatform] = useState<'ios' | 'base'>('base');

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();
        setPlatform(/iphone|ipad|ipod/.test(ua) ? 'ios' : 'base');
    }, []);

    return (
        <AppRoot appearance="dark" platform={platform}>
            <HashRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Landing />} />
                        <Route path="/games" element={<Games />} />
                        <Route path="/games/:gameId" element={<GameRoom />} />
                        <Route path="/games/:gameId/purchase" element={<TicketPurchase />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/deposit" element={<BotMoney />} />
                        <Route path="/cashout" element={<BotMoney />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </HashRouter>
        </AppRoot>
    );
}
